import React, { Component } from 'react';
import { Form, message, Modal, Row } from 'antd';

import { queryProtectionInfo } from '@api/xxcrm/protect';

const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  componentDidMount() {
    this.loadDetail(this.props.protectUuid);
  }

  /**
   * 获取客户保护详情
   */
  loadDetail = uuid => {
    queryProtectionInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { cancel } = this.props;
    const { data } = this.state;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Modal title="查看" width={400} visible onCancel={cancel} footer={false}>
        <Form className="modal" layout="inline">
          <Row>
            <FormItem label="公司名称" {...formItemLayout}>
              <p>{data.name}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人姓名" {...formItemLayout}>
              <p>{data.contactName}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人电话" {...formItemLayout}>
              <p>{data.phone}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="联系人手机" {...formItemLayout}>
              <p>{data.mobile}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="行业" {...formItemLayout}>
              <p>{data.industry}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="公司网址" {...formItemLayout}>
              <p className="word-wrap">{data.url}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="法人姓名" {...formItemLayout}>
              <p>{data.legal}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="公司地址" {...formItemLayout}>
              <p>{data.area}</p>
            </FormItem>
          </Row>
          <Row>
            <FormItem label="详细地址" {...formItemLayout}>
              <p>{data.addr}</p>
            </FormItem>
          </Row>
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(Index);



// WEBPACK FOOTER //
// ./src/components/xianxing/protect/DetailCus.js